import React, { useContext } from 'react';

import { PlayerSelector } from './Components/PlayerSelector/PlayerSelector';
import { TeamSelector } from './Components/TeamSelector/TeamSelector';
import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from './Context/TeeSheetCreator.context';
import { Modal } from '../../../../components/Modal/Modal';
import { GlobalContext } from '../../../../store';

export const MobileSelectorModal = () => {
  const {
    adminEvents: { current: event }
  } = useContext(GlobalContext);

  const { dispatch } = useTeeSheetCreatorDispatch();

  const { modalOpen } = useTeeSheetCreatorState();

  const closeModal = () => {
    dispatch({ type: 'set', value: { attribute: 'addTeamActive', value: false } });
    dispatch({ type: 'set', value: { attribute: 'modalOpen', value: false } });
  };

  return (
    <Modal
      onClose={closeModal}
      className="teams-creator-modal"
      open={modalOpen}
      hideCloseButton={true}
      goBackText="Done"
    >
      {event && event.allowTeams ? <TeamSelector /> : <PlayerSelector />}
    </Modal>
  );
};
